<!--
/*
* date component
* feature 
* default
* range : {from, to}
* min
* max
*/
/-->
<template>
<div class="datepicker">
	<template v-if="range !== undefined">
		<div class="date-box">
			<input type="text" class="date" readonly
				v-model="fromDate"
				v-on:click="currentDate('from')" />
		</div>
		<div class="date-box" style="padding:0 8px;">~</div>
		<div class="date-box">
			<input type="text" class="date" readonly
				v-model="toDate"
				v-on:click="currentDate('to')" />
		</div>
	</template>
	<template v-else>
		<div class="date-box">
			<input type="text" class="date" readonly
				v-model="fromDate" v-on:click="currentDate('from')" />
		</div>
	</template>

	<transition name="slide-fade"
		v-on:before-enter="calendarOpen"
		v-on:after-leave="calendarClose">
		<div class="calendar-container" v-if="toggle">
			<div class="calendar side-bar">
				<button class="cal-close" v-on:click="toggle = !toggle"></button>
				<div class="cal-head">
					<h3 class="title">{{`${year}.${(month + 1) >= 10 ? month + 1 : '0' + (month + 1)}`}}</h3>
					<button class="prev" v-on:click="prevMonth">prev</button>
					<button class="next" v-on:click="nextMonth">next</button>
				</div>
				<div class="cal-body">
					<div class="week">
						<span class="label" v-for="(day, index) in weeks" v-bind:key="`${engWeeks[index]}`">{{`${weeks[index]}`}}</span>
					</div>
					<div class="week" v-for="(week, index) in daysMatrix" v-bind:key="`week-${index}`">
						<day v-for="(day, index) in week"
							:key="index"
							:date="day"
							:min="minDate"
							:max="maxDate"
							:from="startDayTime"
							:to="endDayTime"
							:toDay="toDayTime"
							:selectLimit="selectLimit(day.timestamp)"
							@selectedDay="selectedDay" />
					</div>
				</div>
			</div>
		</div>
	</transition>
</div>
</template>

<script>
import Day from './day';

export default {
	props:['range', 'min', 'max', 'defaultDate'],
	components:{Day},
	data(){
		return {
			gregorianYear:1583,
			year:0,
			month:0,
			day:0,
			days:[],
			choiceIS:false,
			weeks:['일', '월', '화', '수', '목', '금', '토'],
			engWeeks:['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			lastMonthDay:[31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

			from:null,
			to:null,
			toDayTime:0,
			startDayTime:0,
			endDayTime:0,

			minDate:null,
			maxDate:null,

			toggle:false,
			currentState:'from'
		}
	},
	created(){},
	mounted(){
		this.from = (this.range !== undefined) ? new Date(this.range.from) : new Date(this.fromDate);
		this.to = (this.range !== undefined) ? new Date(this.range.to) : new Date();
		this.minDate = (this.min !== undefined) ? new Date(this.min) : null;
		this.maxDate = (this.max !== undefined) ? new Date(this.max) : null;

		this.toDayTime = new Date().getTime(); // 날짜 고정이 필요할듯..
		this.startDayTime = this.from.getTime();
		this.endDayTime = this.to.getTime();
	},
	computed:{
		daysMatrix(){
			// 율리우스력 1년 길이는 365.25이고, 그레고리력의 1년 길이는 365.2425일이므로, 천문학의 회귀년보다 0.0003일(26초)이 길고 약 3,300년마다 1일의 편차가 난다.
			// 한국에서는 1895년 10월 26일(음력 9월 9일)에 조선 정부(을미개혁, 김홍집 내각)가 같은 해 음력 11월 17일을 1896년 1월 1일로 하였고,
			// 태양력 채택을 기념하여 연호를 건양(建陽)으로 변경하여 현재 대한민국도 그레고리력을 쓰고 있다.
			
			// 1) 4년으로 나누어지는 해는 윤달이 있다.
			// 2) 그러나 100년으로 나누어지는 해는 윤달이 없다.
			// 3) 그러나 400년으로 나누어지는 해는 윤달이 있다.
			// (시작일 요일 + (( 평년합 X 1 + 윤년합 X 2 ) % 7)) % 7 시작 요일구하기 공식

			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			this.lastMonthDay[1] = (this.year % 4 === 0 && this.year % 100 !== 0 || this.year % 400 === 0) ? 29 : 28;
			const yunYear = this.translateYear(this.year) - this.translateYear(this.gregorianYear);  //1583년 ~ 올해 까지 윤년의 합
			const normalYear = (this.year) - this.gregorianYear - yunYear; //1583년 ~ 올해 까지 평년의 합
			const yearStartWeek = (6 + ((normalYear + (yunYear * 2)) % 7)) % 7; //올해 1월 1일의 요일
			const monthStartWeek = (this.month !== 0) ? ((this.lastMonthDay.slice(0, this.month)).reduce((a,b)=>a+b) + yearStartWeek) % 7 : yearStartWeek % 7; //이번달 1일의 요일

			return this.daysTable(monthStartWeek, this.month);
		},
		fromDate(){
			return this.$moment(this.from).format('YYYY/MM/DD');
		},
		toDate(){
			return this.$moment(this.to).format('YYYY/MM/DD');
		},
		today() {
			return this.$moment(new Date()).format('YYYY/MM/DD');
		}
	},
	watch: {
		defaultDate: {
			immediate: true,
			deep:false,
			handler(v) {
				this.from = new Date(v);
			}
		}
	},
	methods:{
		translateYear(year){
			// year의 윤년계산
			// 코페루니쿠스 그레고리력의 365.2524일에서 365을 뺀 0.2524가 97/400이 되므로 400년간 97일의 윤년을 끼워넣으면된다.
			return Math.floor((year-1)/4) - Math.floor((year-1)/100) + Math.floor((year-1)/400);
		},
		daysTable(week, month){
			const day = this.lastMonthDay[month] + week;
			const totalCell = day + Math.ceil(day / 7);
			const monthCell = [];
			let weekCell = [];

			for(let i=0; i < totalCell; i++){
				const temp = i >= week && i < day ? i-week+1:0;
				weekCell.push({
					day:temp,
					timestamp:temp > 0 ? new Date(`${this.year}/${this.month+1}/${temp}`).getTime() : 0
				});
				if(weekCell.length >= 7){
					monthCell.push(weekCell);
					weekCell = [];
				}
			}
			return monthCell;
		},
		prevMonth(){
			(this.month <= 0) ? (() => {this.month = 11; this.year--})() : this.month--;
		},
		nextMonth(){
			(this.month >= 11) ? (() => {this.month=0; this.year++})() : this.month++;
		},
		calendarOpen(){
			document.getElementsByTagName('html')[0].setAttribute('class', 'fix');
		},
		calendarClose(){
			document.getElementsByTagName('html')[0].setAttribute('class', '');
		},
		currentDate(status){
			this.toggle = !this.toggle;
			this.currentState = status;
			this.year = (status === 'from') ? this.from.getFullYear() : this.to.getFullYear();
			this.month = (status === 'from') ? this.from.getMonth() : this.to.getMonth();
			this.day = (status === 'from') ? this.from.getDate() : this.from.getDate();
		},
		selectedDay(day){
			const date = `${this.year}/${this.month+1}/${day}`;
			this.toggle = !this.toggle;

			switch(this.currentState){
				case 'from':
					this.from = new Date(date);
					this.startDayTime = this.from.getTime();
					break;
				case 'to':
					this.to = new Date(date);
					this.endDayTime = this.to.getTime();
					break;
			}

			this.$emit('selectedDate', date);
		},
		selectLimit(timestamp){
			return (this.currentState === 'from') ? (timestamp > this.endDayTime) : (timestamp < this.startDayTime);
		}
	}	
}
</script>

<style lang="scss" scoped>
.datepicker {
	display: table;
	width: 100%;
	border: 1px solid #e0e0dd;
    border-radius: 8px;

	.date-box {
		display: table-cell;
		border: none;
		text-align: left;

		.date {
			width: 100%;
			height: 50px;
			padding-bottom: 1px;
			border: none;
			background: url(../../assets/images/ico_calendar.svg) no-repeat right 0.75em center;
			cursor: pointer;
		}
	}
}

.calendar-container {
	position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.5);

	.calendar {
		position: absolute;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		min-width: 320px;
		max-width: 375px;
		margin: 0 auto;
		padding: 0 1.2em 1em;
		border-top-right-radius: 20px;
		border-top-left-radius: 20px;
		box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.1);
		background: #fff;

		.cal-close {
			position: absolute;
			top: -56px;
			right: 0;
			left: 0;
			width: 45px;
			height: 45px;
			margin: 0 auto;
			border: 1px solid #fff;
			border-radius: 100%;
			background: url(../../assets/images/ico_close_white.svg) no-repeat 50% 50%;
			opacity: 0.9;
		}

		.cal-head {
			position: relative;
			height: 60px;
			line-height: 60px;
			margin: 0 auto 1.1em;
			border-bottom: 1px solid #ddd;

			.title {
				text-align: center;
				font-size: 1.25em;
			}

			.prev {
				position: absolute;
				top: 0;
				left: 0;
				z-index: 5;
				width: 32px;
				height: 100%;
				background: url(../../assets/images/ico_arrow_left_gray.svg) no-repeat 50% 50%;
				text-indent: -9999px;
			}

			.next {
				position: absolute;
				top: 0;
				right: 0;
				z-index: 5;
				width: 32px;
				height: 100%;
				background: url(../../assets/images/ico_arrow_left_gray.svg) no-repeat 50% 50%;
				-webkit-transform: rotate(180deg);
				-ms-transform: rotate(180deg);
				transform: rotate(180deg);
				text-indent: -9999px;
			}
		}

		.cal-body {
			// max-width: 310px;
			margin: 0 auto;
			// padding: 0.5em 0 1em;

			.week {
				display: table;
				width: 100%;

				&:first-child {
					.label {
						height: 40px;
						font-size: 15px;
						color: #b9b9b9;

						&:first-child {
							color: #f04137;
						}
						&:last-child {
							color: #4285f4;
						}
					}
				}

				.label {
					display: table-cell;
					width: calc(100% / 7);
					height: 30px;
					text-align: center;
					vertical-align: middle;
				}
			}	
		}
	}
}

.slide-fade-enter-active,
.slide-fade-leave-active,
.side-bar {
	-webkit-transition: all .5s ease;
	-moz-transition: all .5s ease;
	transition: all .5s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
	opacity: 0;

	.side-bar {
		-webkit-transform: translateY(100px);
		-moz-transform: translateY(100px);
		transform: translateY(100px);
	}
}
</style>
